<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="$modal.closeModal"
    >
      <header class="m-the-modal-header m-the-modal-header-title-error">
        {{ $t('mFeedSectionContentCardEditionDesignModal.fileExtensionError.header') }}
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p>{{ $t('mFeedSectionContentCardEditionDesignModal.fileExtensionError.section') }}</p>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeFeedSectionContentCardEditionModalFileExtensionError',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mFeedSectionContentCardEditionDesignModal.fileExtensionError.button'),
        class: `a-button-${this.$modal.element.seccion}-primary`,
        sending: false,
        type: 'submit'
      }
    }
  }
}
</script>
